export enum ITabName {
  SHIPPING,
  PAYMENT,
  REVIEW,
}
